export class Pallets{
  id:number;
  qr_code:string;
  number:string;
  location_id:number;
  x:number;
  y:number;
  z:number;
  amount:number;
  prefix:string;
  suffix:number;

  constructor(id,qr,codigo,x,y,z,cantidad,prefix,suffix){
    this.id = id;
    this.qr_code = qr;
    this.number = codigo;
    this.x = x;
    this.y = y;
    this.z = z;
    this.amount = cantidad;
    this.prefix = prefix;
    this.suffix = suffix;
  }

/**
 * Crea el formato JSON para el envio a través de HTTP
 * @return JSON a enviar.
 */
  public getJson(){
    // let nul1 = '';
    // let nul2 = '';
    // let nul3 = '';
    // if(this.guia != '' && this.guia != null){
    //   nul1 = `"guide":"${this.guia}",`;
    // }
    // if(this.ret != '' && this.ret != null){
    //   nul2 = `"ret":"${this.ret}",`;
    // }
    // if(this.centro != '' && this.centro != null){
    //   nul3 = `"headquarter":"${this.centro}",`;
    // }

    return `{
      "data":{
        "type": "pallets",
        "id": "${this.id}",
        "attributes": {
          "id":"${this.id}",
          "qr_code":"${this.qr_code}",
          "number":"${this.number}",
          "location_id":"${this.location_id}",
          "x":"${this.x}",
          "y":"${this.y}",
          "z":"${this.z}",
          "amount":"${this.amount}",
          "prefix":"${this.prefix}",
          "suffix":"${this.suffix}"
        }
      }
    }`;
  }

  /**
   * Crea el formato JSON para el envio a través de HTTP
   * @return JSON a enviar.
   */
    public getJson2(id:number,amount:number){
      return `{
        "data":{
          "type": "pallets",
          "id": "${id}",
          "attributes": {
            "id":"${id}",
            "amount":"${amount}"
          }
        }
      }`;
    }

/**
 * Crea el formato JSON para el envio a través de HTTP
 * @return JSON a enviar.
 */
  public getJson3(){
    return `{
      "data":{
        "type": "pallets",
        "attributes": {
          "prefix":"${this.prefix}"
        }
      }
    }`;
  }

  public getJson4(pallets){
    let coma =',';
    let esp = '';
    let pos = 0;

    for(let pallet of pallets){
      pos +=1;
      if(pos === pallets.length){
        coma = '';
      }
      esp += `{"type":"pallets","id":${pallet.id}}${coma}`;
    }
    return `{"data":[${esp}]}`;
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/model/Pallets.ts